import style from './wallex-title.module.scss'
import { InView } from 'react-intersection-observer';
import animations from '@styles/animations.module.scss'

const WallexTitle = (props: any) => {
    let { state, size = 'lg' } = props;
    return (
        <InView triggerOnce={true}>
            {({ inView, ref, entry }) => {
                if (inView) {
                    entry?.target.classList.add(animations.active);
                }
                return (
                    <>
                        <h1 ref={ref} className={`${style.wallex__title} ${style[size]} ${animations.scroll__animation}`}>
                            {state}
                        </h1>
                    </>
                )
            }}
        </InView>
    )


}

export default WallexTitle;
